// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"284":"413b83843c409412b45a0c2692fc674f","899":"7c2fd2490999ca39d53994d7b280fdab"}[chunkId] + ".js";
};